import { axiosInstance } from "./config";

const BASE_URL = "/project";

/**
 * GET PROJECT STATS
 */
export const getProjectStats = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/stats`);
  return res.data;
};

/**
 * GET ALL PROJECTS
 */
export const getAllProjects = async () => {
  const res = await axiosInstance.get(BASE_URL);
  return res.data;
};
export const getDashboardData = () =>
  axiosInstance.get(`${BASE_URL}/dashboard`);

/**
 * CREATE PROJECT
 */
export const createProject = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data);
  return res.data;
};

/**
 * GET PROGRAMS BY PROJECT
 */
export const getProgramsByProject = async (projectName) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/${projectName}/programs`
  );
  return res.data;
};

 
export const getBranchProjects = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/branch-projects`);
  return res.data;
};

 
export const getAllProgramsByProject = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/all-programs`);
  return res.data;
}
 export const API_BASE_URL ="api2.eduforestin.com";
 